import React from 'react';
import { Facebook, Twitter, Linkedin, Youtube } from 'lucide-react';

const ICONS = {
  Facebook,
  Twitter,
  LinkedIn: Linkedin,
  YouTube: Youtube,
};

const SocialLinks = ({ links }) => (
  <div className="space-y-3 mb-8">
    {links.map((social) => {
      const Icon = ICONS[social.name];
      return (
        <a
          key={social.name}
          href={social.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`footer-social-${social.name.toLowerCase()}`}
          className="flex items-center gap-3 text-sm text-gray-600 hover:text-[#00BCE4] transition-colors duration-300"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          {Icon && <Icon size={16} />}
          {social.name}
        </a>
      );
    })}
  </div>
);

export default SocialLinks;
